import Services from "../../../services";

export default {
  getToken({ state, commit }, data) {
    commit("SET_ACCESS_TOKEN", data.access_token);
    commit("SET_REFRESH_TOKEN", data.refresh_token);
    commit("SET_ID_TOKEN", data.id_token);
  },

  getUserInfo({ state, commit }, data) {
    return Services.getUserInfo(data.token_type, data.access_token)
      .then(async (response) => {
          commit("SET_USER_INFO", response.data);
          commit("SET_USER_STATUS", "YES");
      })
      .catch((error) => {
        commit("SET_ERROR", error.message);
      })
      .finally();
  },

  updateTime({ state, commit }, value) {
    commit("SET_TIMER", value);
  },

  updateTimeInterval({ state, commit }, value) {
    commit("SET_TIME_INTERVAL", value);
  },
};
